import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { Host } from "../commonInterfaces";
import { Saveable } from "../core/components/commonApp";
import { BaseColumn, CheckBoxColumn, DataEntryColumn, EditableGrid, field, Schema } from "../core/components/editableGrid/editableGrid";
import { MultiSelect, MultiSelectProps } from "../core/components/multiSelect";
import { ToolBar, ToolBarCustomButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { Config } from "../core/config/config";
import { ComponentHelper } from "../core/util/componentHelper";
import { DialogHelper } from "../core/util/dialogHelper";
import { Helper } from "../core/util/helper";
import { HTTPService } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import DocumentsListApp, { DocumentsListAppProps } from "../documents/documents";
import { BasicDialog } from "../statistics/reactcomponent";
import React from "react";
export class CRReportMaterialSaveable implements Saveable {
    private host: Host;
    private hasChanges;

    constructor(host: Host) {
        this.host = host;
    }

    GetMenuItem(onClick): any {
        return null;
    }

    HasChanges(): boolean {
        return this.hasChanges;
    }

    private handleChange = () => {
        this.hasChanges = true;
        if (this.host) {
            this.host.notifyChange();
        }
    }

    Save() {

    }

    GetComponent(keyVal1: string, keyVal2: string, props: null, recordRight: any): any {
        return <CrReportMaterialAssignment
            projectNo={keyVal1}
            pIndex={keyVal2}
        />;
    }
}

interface CrReportMaterialAssignmentProps {
    projectNo: string
    pIndex: string
    onChange?: any
    context?: { saveText: () => void }
    additionalDataDynamicApiId?: string;
    additionalDataTemplate?: string;
    defaultDescriptionTemplate?: string
}

interface CrReportMaterialAssignmentState {
    ticketNo: number
    reports: Report[]
    ticketMaterial: Material[]
    selectedMachineId?: string
    selectedReportId?: string
    selectedMachineMaterial?: Material[]
    showCopyDialog?: boolean
    materialsToCopy?: any
    reportText?: string
}


export default class CrReportMaterialAssignmentWrapper extends React.Component<any, any>{
    render() {
        return <CrReportMaterialAssignment
            projectNo={this.props.context.projectNo}
            pIndex={this.props.context.pIndex}
            onChange={this.props.onChange}
            context={this.props.context}
            additionalDataDynamicApiId={this.props.additionalDataDynamicApiId}
            additionalDataTemplate={this.props.additionalDataTemplate}
            defaultDescriptionTemplate={this.props.defaultDescriptionTemplate}
        />;
    }
}

export class CrReportMaterialAssignment extends React.Component<CrReportMaterialAssignmentProps, CrReportMaterialAssignmentState>{
    private _api = new Api(Config.baseUrl);
    private debouncedReload;

    constructor(props) {
        super(props);
        this.state = { ticketNo: null, reports: [], ticketMaterial: [] };
        this.debouncedReload = Helper.debounce(this.reloadReports, 3000);
    }

    async componentDidMount() {
        const ticketNo = await this._api.getTicketNo(this.props.projectNo, this.props.pIndex);
        const reports = await this._api.getReports(this.props.projectNo, this.props.pIndex, this.props.additionalDataDynamicApiId);
        const ticketMaterial = await this._api.getTicketMaterial(ticketNo);
        const machineMaterial = this.state.selectedMachineId && ticketMaterial.filter((m) => m.Maschnr == this.state.selectedMachineId);
        this.setState({ ticketNo: ticketNo, reports: reports, ticketMaterial: ticketMaterial, selectedMachineMaterial: machineMaterial });
    }

    private openSheetAsync = (reactComponent, props, title: string): Promise<boolean> => {
        const sheet = General.Sheet.Manager.createSheet();
        sheet.show(() => {
            sheet.setTitle(title);
            sheet.mountContent(reactComponent, props);
            General.Drawer.Left.disable();
        });
        return new Promise<boolean>((resolve, reject) => {
            sheet.bind(SheetEventType.Close, (data: any) => {
                resolve(true);
            });
        });
    }

    private _handleOpenQuanosCatalog = async () => {
        document.cookie = "PHPSESSID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        const url = await this._api.getTidShoppingCartUrl(this.state.ticketNo, this.state.selectedMachineId);
        if (!Helper.hasValue(url)) {
            DialogHelper.alert(Helper.getTranslation("Reports.Material.KeinKatalogMaschine"));
            return;
        }
        await this.openSheetAsync(QuanosIFrame, { url: (Config.baseUrl + "Tid/catalog/p1/p2?" + url) }, Helper.getTranslation("WebSMS.Quanos.Name"))
        const message = await this._api.processTidShoppingCart(this.state.ticketNo);
        await this._api.addMissingMachinesToPromasch(this.state.ticketNo);

        if (message) {
            DialogHelper.alert(message);
        }
        await this._reloadMaterial();
        const reports = await this._api.getReports(this.props.projectNo, this.props.pIndex, this.props.additionalDataDynamicApiId);
        this.setState({ reports: reports });
    }

    private _reloadMaterial = async () => {
        const ticketMaterial = await this._api.getTicketMaterial(this.state.ticketNo);
        const machineMaterial = ticketMaterial.filter((m) => m.Maschnr == this.state.selectedMachineId);
        this.setState({ ticketMaterial: ticketMaterial, selectedMachineMaterial: machineMaterial });
    }

    private reloadReports = async () => {
        const reports = await this._api.getReports(this.props.projectNo, this.props.pIndex, this.props.additionalDataDynamicApiId);
        this.setState({ reports: reports });
    }

    private _handleSelectedMachineChange = async (selectedMachineId: string, reportId: string) => {
        if (selectedMachineId != this.state.selectedMachineId || reportId != this.state.selectedReportId) {
            const machineMaterial = selectedMachineId && this.state.ticketMaterial.filter((m) => m.Maschnr == selectedMachineId);
            const text = await this._api.getText(reportId);
            this.setState({ selectedMachineId: selectedMachineId, selectedMachineMaterial: machineMaterial, reportText: text, selectedReportId: reportId });
        }
    }

    private _handleCopy = async (reports: string[]) => {
        await this._api.copyToOtherMachines(this.state.ticketNo, this.state.materialsToCopy, reports);
        await this._reloadMaterial();
    }

    private _handleDeleteMaterial = async (selectedArticles: number[]) => {
        if (!selectedArticles || selectedArticles.length == 0) {
            return;
        }
        const result = await DialogHelper.confirm(Helper.getTranslation("Reports.Material.LoeschenFrage"));
        if (result) {
            await this._api.deleteMaterial(this.state.ticketNo, selectedArticles);
            await this._reloadMaterial();
            const reports = await this._api.getReports(this.props.projectNo, this.props.pIndex, this.props.additionalDataDynamicApiId);
            this.setState({ reports: reports });
        }
    }

    private _handleCountChanged = async (pos: number, count: number) => {
        await this._api.changeCount(this.state.ticketNo, pos, count);
        const material = this.state.ticketMaterial.filter((m) => m.Pos == pos)[0];
        material.Anzahl = count;
    }

    private _handleReportPreview = () => {
        const url = `Reporting/OpenEdit?id=${this.state.selectedReportId}&typeId=5`;

        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, null, true);
        sheet.bind(SheetEventType.Close, async () => {
            const reports = await this._api.getReports(this.props.projectNo, this.props.pIndex, this.props.additionalDataDynamicApiId);
            this.setState({ reports: reports });
        });
    }

    private _renderCopyDialog = () => {
        return this.state.showCopyDialog ? <CopyMaterialDialog
            machines={this.state.reports}
            onClose={() => this.setState({ showCopyDialog: false })}
            onCopy={this._handleCopy} /> : null
    }

    private getSelectedReport = (): Report => {
        const selectedReport = this.state.reports && this.state.reports.filter(r => r.ServiceReportId == this.state.selectedReportId);
        return selectedReport && selectedReport.length > 0 && selectedReport[0];
    }

    private _handleShowDocuments = () => {
        const props: DocumentsListAppProps = {
            entity: Helper.createEmptyEntity(),
            context: {
                contextType: "",
                keyVal1: this.state.ticketNo,
                key1: "",
                key2: ""
            },
            type: 2,
            selectMode: true,
            onRequestDefaults: () => {
                if (this.props.defaultDescriptionTemplate) {
                    const report = this.getSelectedReport();
                    const template = kendo.template(this.props.defaultDescriptionTemplate);
                    const result = template({ row: report });
                    if (report) {
                        return { description: result, title: "", descriptionReadOnly: true }
                    }
                }

                return null;
            }
        }
        this.openSheetAsync(DocumentsListApp, props, Helper.getTranslation("Dokument.Dokumente"))
    }

    private handleIdle = async (reportId, newValue: string) => {
        this.debouncedReload();
    }

    render() {
        return <div style={{ display: "flex", height: "100%" }}>
            <ReportsList reports={this.state.reports}
                onReportClick={this._handleSelectedMachineChange}
                onShowReportPreview={this._handleReportPreview}
                selectedReport={this.state.selectedReportId}
                customDataTemplate={this.props.additionalDataTemplate}
            />
            {this._renderCopyDialog()}
            {this.state.selectedMachineId ?
                <div style={{ display: "flex", flex: "1", flexDirection: "column", margin: "10px" }}>
                    <ReportMaterial
                        onOpenQuanosCatalog={() => { this._handleOpenQuanosCatalog() }}
                        onOpenCopyDialog={(materialToCopy) => { materialToCopy && materialToCopy.length > 0 && this.setState({ showCopyDialog: true, materialsToCopy: materialToCopy }) }}
                        onDeleteMaterial={this._handleDeleteMaterial}
                        onCountChanged={this._handleCountChanged}
                        onOpenSelectedreport={this._handleReportPreview}
                        showDocuments={this._handleShowDocuments}
                        material={this.state.selectedMachineMaterial} />
                    <div style={{ marginTop: "10px" }}>
                        <LabelComponent text={Helper.getTranslation("Reports.Material.TextVertriebsanfrage") }></LabelComponent>
                    </div>
                    <Vertriebsanfrage key={this.state.selectedReportId}
                        defaultValue={this.state.reportText}
                        reportID={this.state.selectedReportId}
                        onChangedTextSaved={this.handleIdle.bind(this, this.state.selectedReportId)} />
                </div>
                : null}
        </div>
    }
}

interface VertriebsfrageProps { defaultValue: string, onChangedTextSaved: (newValue: string) => void, reportID: string };

class Vertriebsanfrage extends React.Component<VertriebsfrageProps, { savedText: string, isSaving: boolean, lastChangeTimeStamp?: number }>{
    private lastTriggeredValue: string;
    private debouncedChange;
    private _api = new Api(Config.baseUrl);
    private textArea: HTMLTextAreaElement;
    private interval: number;

    constructor(props: VertriebsfrageProps) {
        super(props)
        //this.debouncedChange = Helper.debounce(this.triggerChange, 100);
        this.state = { savedText: props.defaultValue, isSaving: false };
    }

    triggerChange = async () => {
        if (Date.now() - this.state.lastChangeTimeStamp <= 500) {
            return;
        }
        if (this.state.isSaving || (this.state.savedText ?? '') == this.textArea.value) {
            return;
        }
        this.setState({ isSaving: true }, async () => {
            const currentValue = this.textArea.value;
            const savedText = await this._api.setText(this.props.reportID, currentValue);
            this.props.onChangedTextSaved(currentValue);
            NotificationHelper.showSuccessMessage(Helper.getTranslation("Standard.SaveSuccessfully"));
            this.setState({ savedText, isSaving: false });
        });
    }

    handleChange = () => {
        this.setState({ lastChangeTimeStamp: Date.now() })
    }

    renderChangeIndicator = () => {
        let color = "green";
        if (this.textArea) {
            if (this.state.isSaving) {
                color = "yellow";
            }
            else if (this.state.savedText == this.textArea.value) {
                color = "green";
            }
            else {
                color = "red";
            }
        }
        return <div style={{ backgroundColor: color, height: "10px" }}></div>;
    }

    componentDidMount() {
        this.interval = window.setInterval(() => this.triggerChange(), 200);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        return <>
            {this.renderChangeIndicator()}
            <textarea ref={(e) => this.textArea = e} style={{ height: "250px", resize: "none" }}
                onChange={this.handleChange}
                defaultValue={this.props.defaultValue}></textarea>
        </>
    }
}

interface ReportListProps {
    reports: Report[]
    onReportClick: (machineId: string, reportId: string) => void
    onShowReportPreview: (reportId: string) => void
    selectedReport: string
    customDataTemplate: string
}

class ReportsList extends React.Component<ReportListProps, { filter?: string }>{
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleFilterChange = (e) => {
        this.setState({ filter: e.target.value });
    }

    renderReport = (report: Report) => {
        return <ReportComponent
            key={report.ServiceReportId}
            onClick={this.props.onReportClick}
            reportId={report.ServiceReportId}
            reportName={report.Description}
            machineId={report.MachineNumber}
            onShowReportPreview={this.props.onShowReportPreview}
            isCompleted={report.Completed}
            isSelected={report.ServiceReportId == this.props.selectedReport}
            customReadOnlyData={report.CustomReadOnlyData}
            customDataTemplate={this.props.customDataTemplate}
            machineName={report.Maschbezeichnung}></ReportComponent>
    }

    render() {
        let filteredReports = this.state.filter ? this.props.reports.filter((r) => r.CustomReadOnlyData && r.CustomReadOnlyData.MAIND_ANLAGENNUMMER && r.CustomReadOnlyData.MAIND_ANLAGENNUMMER.indexOf(this.state.filter) > -1) : this.props.reports;
        return <div style={{
            width: "250px", margin: "10px", display: "flex", flexDirection: "column"
        }}>
            <LabelComponent text={Helper.getTranslation("WebSMS.Reporting.Reports")}></LabelComponent>
            <input type="text" style={{ marginTop: "5px" }} value={this.state.filter || ''} onChange={this.handleFilterChange} placeholder={Helper.getTranslation("Reports.Material.AnlagenNr")} />
            <ul style={{ overflow: "auto", flex: "1" }}>
                {this.props.reports && filteredReports.map(r => this.renderReport(r))}
            </ul>
        </div>
    }
}

interface ReportComponentProps {
    reportId: string
    reportName: string
    machineName: string
    machineId: string
    onClick: (machineId: string, reportId: string) => void
    onShowReportPreview: (reportId: string) => void
    isSelected: boolean
    isCompleted: boolean
    customReadOnlyData: any
    customDataTemplate: string
}

function ReportComponent(props: ReportComponentProps) {
    const renderCutomData = () => {
        if (props.customReadOnlyData && props.customDataTemplate) {
            const template = kendo.template(props.customDataTemplate);
            const result = template({ row: props.customReadOnlyData });
            return <div dangerouslySetInnerHTML={{ __html: result }}></div>
        }
        return;
    }

    return <li style={{ cursor: "pointer", border: "black solid 1px", marginTop: "5px", backgroundColor: props.isSelected ? "#eaeaea" : null }}
        onClick={() => props.onClick && props.onClick(props.machineId, props.reportId)}>
        <div style={{ fontWeight: "bold", display: "inline" }}>{Helper.getTranslation("Field.fstasks.ExtendedTemplate.SearchReports")}:</div>{props.reportName}
        {props.isCompleted ? < div className='grid-icon-custom-center' style={{ color: '#66bb6a', width: '25px', display: 'inline-block' }}><i className='far fa-thumbs-up'></i></div> : null}
        <div style={{ fontWeight: "bold" }}>{Helper.getTranslation("WebSMS.Reporting.Fields.Maschine")}: </div>{props.machineName}/{props.machineId}
        {renderCutomData()}
    </li>
}

function LabelComponent(props: { text: string }) {
    return <div style={{ display: "flex", alignItems: "center", height: "33px", backgroundColor: "#eaeaea" }}>
        <div style={{ fontWeight: "bold", marginLeft: "10px" }}>{props.text}</div>
    </div>
}

enum CustomCommand {
    CopyMat = "copyMat",
    OpenReport = "openReport",
    ShowDocuments = "showDocuments"
}

interface ReportMaterialProps {
    material: Material[]
    onOpenQuanosCatalog: () => void
    onOpenCopyDialog: (selectedMaterialIds: number[]) => void
    onDeleteMaterial: (selectedMaterialIds: number[]) => void
    onCountChanged: (pos: number, count: number) => void
    onOpenSelectedreport: () => void
    showDocuments: () => void
}

class ReportMaterial extends React.Component<ReportMaterialProps, {}>{
    private columns: BaseColumn[];
    private schema: Schema;
    private _grid: EditableGrid;

    constructor(props) {
        super(props);
        const countColumn = new DataEntryColumn();
        countColumn.title = Helper.getTranslation("Field.BelegMaterial.anzahl");
        countColumn.field = "Anzahl";

        const articleNo = new DataEntryColumn();
        articleNo.title = Helper.getTranslation("Field.Material.artikelnummer");
        articleNo.field = "Artikelnummer";

        const description = new DataEntryColumn();
        description.field = "Bezeichnung";
        description.title = Helper.getTranslation("Field.BelegMaterial.bezeichnung");

        const fromCar = new CheckBoxColumn();
        fromCar.field = "VomAuto";
        fromCar.title = Helper.getTranslation("Reports.Material.VomAuto");

        this.columns = [articleNo, description, countColumn];

        this.schema = new Schema();
        this.schema.Id = "IsGuid";
        this.schema.fields["Anzahl"] = new field("number", true);
        this.schema.fields["Artikelnummer"] = new field("string", false);
        this.schema.fields["Bezeichnung"] = new field("string", false);
        this.schema.fields["AnlagenNr"] = new field("string", false);
        this.schema.fields["VomAuto"] = new field("boolean", true);

        this.state = { showCopyDialog: false };
    }

    private _handleButtonClick = (type: ToolBarStandardButtonType) => {
        if (type == ToolBarStandardButtonType.NEW) {
            this.props.onOpenQuanosCatalog()
        } else if (type == ToolBarStandardButtonType.DELETE) {
            const selectedKeys = this._getSelectedKeys();
            this.props.onDeleteMaterial(selectedKeys);
        }
    }

    private _getSelectedKeys = (): number[] => {
        const selectedKeys: number[] = []
        this._grid.getSelectedItems().each((i, item) => {
            selectedKeys.push(item["Pos"]);
        });
        return selectedKeys;
    }

    private _handleClickCustomButton = (id: CustomCommand) => {
        if (id == CustomCommand.CopyMat) {
            const selectedKeys = this._getSelectedKeys();
            this.props.onOpenCopyDialog(selectedKeys);
        }
        else if (id == CustomCommand.OpenReport) {
            this.props.onOpenSelectedreport();
        }
        else if (id == CustomCommand.ShowDocuments) {
            this.props.showDocuments();
        }
    }

    private _handleFieldChanged = (p) => {
        if (!this.props.onCountChanged) {
            return;
        }
        const value = p.values["Anzahl"];
        if (Helper.hasValue(value)) {
            this.props.onCountChanged(p.model.Pos, value);
        }
    }

    render() {
        const stdBtn: Array<ToolBarStandardButton> = [];
        const cusBtn: Array<ToolBarCustomButton> = [];

        stdBtn.push({
            caption: "Material aus Katalog importieren",
            enabled: true,
            type: ToolBarStandardButtonType.NEW,
        });
        stdBtn.push({
            caption: Helper.getTranslation("WebSMS.TransEditor.ActionDelete"),
            enabled: true,
            type: ToolBarStandardButtonType.DELETE,
        });

        cusBtn.push({ caption: Helper.getTranslation("ServiceReport.CopyServiceReport.CopyMaterials"), enabled: true, id: CustomCommand.CopyMat, iconClass: "k-i-copy" });
        cusBtn.push({ caption: Helper.getTranslation("Reports.Material.BerichtOeffnen"), enabled: true, id: CustomCommand.OpenReport, iconClass: "k-i-folder-open" });
        cusBtn.push({ caption: Helper.getTranslation("Dokument.Dokumente"), enabled: true, id: CustomCommand.ShowDocuments, iconClass: "k-i-file" });

        return <>
            <LabelComponent text={Helper.getTranslation("Artikel.Artikel") }></LabelComponent>
            <ToolBar standardButtons={stdBtn} handleStandardButtonClick={this._handleButtonClick} customButtons={cusBtn} handleCustomButtonClick={this._handleClickCustomButton} />
            <div style={{ flex: "1" }}>
                <EditableGrid id="crMaterial" onFieldChanged={this._handleFieldChanged} ref={(e) => { this._grid = e }} schema={this.schema} columns={this.columns} data={this.props.material} editable={true}></EditableGrid>
            </div>
        </>
    }
}

export class CopyMaterialDialog extends React.Component<{ machines: { MachineNumber: string }[], onCopy: (selectedMachine: string[]) => void, onClose }, {}>{
    private _componentFactory = ComponentHelper.createFactory();
    private _currentValue;

    private _handleChange = (field, value) => {
        if (value !== null) {
            this._currentValue = value.map((item) => item["MachineNumber"]);
        }
        else {
            this._currentValue = value;
        }
    }

    private _getUniqueMachines = () => {
        if (!this.props.machines) {
            return [];
        }
        const excludeMachine = {};
        const filtered = this.props.machines.filter((m) => { if (excludeMachine[m.MachineNumber]) { return false; } excludeMachine[m.MachineNumber] = true; return true; });
        return filtered;
    }

    render() {

        const comboProps = this._componentFactory.getDefaultMultiSelectProps() as MultiSelectProps;
        comboProps.onDataLoaded = () => { };
        comboProps.onChange = this._handleChange;
        comboProps.disabled = false;
        comboProps.field.required = false
        comboProps.field.model = "foldername";
        comboProps.field.name = "Test"; 
        comboProps.dataSource = this._getUniqueMachines();
        comboProps.field.dataTextField = "Maschbezeichnung";
        comboProps.field.dataValueField = "MachineNumber";

        return <BasicDialog width="500px" title={Helper.getTranslation("Reports.Material.MaterialKopierenMaschine") } onSave={() => { this.props.onCopy(this._currentValue) }} onClose={this.props.onClose}>
            <MultiSelect{...comboProps} />
        </BasicDialog>
    }
}

class Api {
    private baseUrl: string;
    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    getTidShoppingCartUrl = async (problemnr: number, maschnr: string): Promise<string> => {
        const response = await fetch(this.baseUrl + `TidInnosoft/getTIDShoppingCartUrl?problemNr=${problemnr}&maschnr=${maschnr}`, { method: "POST" });
        const jsonResult = await response.json();
        return jsonResult.Data;
    }

    deleteTIDShoppingCart = async (problemnr: number) => {
        const response = await fetch(this.baseUrl + `TidInnosoft/deleteTIDShoppingCart?problemNr=${problemnr}`, { method: "POST" });
    }

    processTidShoppingCart = async (problemnr: number): Promise<string> => {
        const result = await HTTPService.post(`TidInnosoft/processTIDShoppingCart?problemNr=${problemnr}`)
        await this.deleteTIDShoppingCart(problemnr);
        return result.Message;
    }

    checkTidFinished = async (reportId: string): Promise<boolean> => {
        const response = await fetch(this.baseUrl + `Statistic/api/dynamicapi/2d77669e-036b-417d-9b9c-ffd23b65336e/GetData?ISGUID=${reportId}`);
        const tidFinished = await response.json();
        return tidFinished.length > 0 && tidFinished[0].FINISHED == 1;
    }

    finishTid = async (reportId: string) => {
        const response = await fetch(this.baseUrl + `Statistic/api/dynamicapi/ac0b3ca5-60bf-4abf-b8a2-7bcb4c922b66/GetData?ISGUID=${reportId}`);
    }

    getTicketMaterial = async (ticketNo: number): Promise<Material[]> => {
        const response = await fetch(this.baseUrl + `ProcedureArticle/GetGridData?id=${ticketNo}`);
        const jsonResult = await response.json();
        return jsonResult.Data.GridData;
    }

    getReports = async (projectNo: string, pIndex: string, additionalDataDynamicApiId: string): Promise<Report[]> => {
        const response = await fetch(this.baseUrl + `Reporting/GetReportsForRecord?type=5&recordId=${projectNo}&pIndex=${pIndex}&additionalDataDynamicApiId=${additionalDataDynamicApiId ?? ''}`);
        const jsonResult = await response.json();
        const reports: Report[] = jsonResult.Data;
        return reports.filter(x => x.MachineNumber && x.ServiceReportId && (x.Warnings || x.CriticalWarnings || (x.CustomReadOnlyData && x.CustomReadOnlyData.SHOWREPORT == 1)));
    }

    getTicketNo = async (projectNo: string, pIndex: string): Promise<number> => {
        const response = await fetch(this.baseUrl + `CrReportMaterial/GetTicketNo?projectNo=${projectNo}&pIndex=${pIndex}`);
        const jsonResult = await response.json();
        const ticketNo = jsonResult.Data;
        return ticketNo;
    }

    copyToOtherMachines = async (ticketNo: number, selectedArticles: number[], seletedMachines: string[]): Promise<number> => {
        await HTTPService.post(`CrReportMaterial/CopyToOtherMachines?ticketNo=${ticketNo}`, { SelectedArticles: selectedArticles, SelectedMachines: seletedMachines })
        return ticketNo;
    }

    deleteMaterial = async (ticketNo: number, selectedArticles: number[]) => {
        await HTTPService.post(`CrReportMaterial/DeleteMaterial?ticketNo=${ticketNo}`, selectedArticles);
    }

    changeCount = async (ticketNo: number, pos: number, newCount: number) => {
        await HTTPService.post(`CrReportMaterial/ChangeCount?ticketNo=${ticketNo}&pos=${pos}&newcount=${newCount}`);
    }

    getText = async (reportId: string): Promise<string> => {
        const result = await HTTPService.post(`CrReportMaterial/GetAnswerText?reportId=${reportId}`);
        return result.Data;
    }

    setText = async (reportId: string, newText: string): Promise<string> => {
        const result = await HTTPService.noBusyIndicator().post(`CrReportMaterial/UpdateAnswerText?reportId=${reportId}`, { NewText: newText });
        return result.Data;
    }

    addMissingMachinesToPromasch = async (ticketNo: number) => {
        await HTTPService.post(`CrReportMaterial/AddMissingMachinesToPromasch?ticketNo=${ticketNo}`);
    }
}

class QuanosIFrame extends React.Component<any, any>{
    private _iframe: HTMLDivElement;

    componentDidMount() {
        kendo.ui.progress($(this._iframe), true);
    }

    render() {
        return <>
            <div ref={(e) => this._iframe = e}></div>
            <iframe
                style={{ height: "100%", width: "100%" }}
                onLoad={() => { kendo.ui.progress($(this._iframe), false); }}
                src={this.props.url}></iframe>
        </>
    }
}

interface Report {
    Id: string
    ServiceReportId: string
    Completed: boolean
    CompletedByDispatcher: boolean
    CompletedByTechnician: boolean
    Description: string
    IsPlannedReport: boolean
    MachineNumber: string
    Mandatory: boolean
    Maschbezeichnung: string
    Remark: string
    CriticalWarnings: number
    Warnings: number
    CustomReadOnlyData: any
}

interface Material {
    Anzahl: number
    Artikelnr: number
    Artikelnummer: string
    Bemerkung: string
    Bezeichnung: string
    Maschnr: string
    Pos: number
}
